export default {
  show: true,
  clippedOver: true,
  dense: true,
  shrinkOnScroll: false,
  hideOnScroll: false,
  prominent: false,
  floating: false,
};
